import React, { Component } from 'react'
import { Card, Typography } from 'antd'
const { Text } = Typography;

export default class Certifications extends Component {
  render() {
    return (
      <Card>
        This is Certifications
      </Card>
    )
  }
}
